import { Injectable } from "@angular/core";
import { UserService } from "../Service/user.service";
import {
  LoginForm,
  UserModel,
  Users,
  StateModel,
  RegionModel,
} from "../Models/login-form";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { Rewards, WeeksBasedEntriesData } from "../Models/rewards";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class UserProvider {
  public errorMessage: string;
  public loggedInUser: UserModel = new UserModel();
  public campaignRewards: Rewards;
  public rewardEntriesData: WeeksBasedEntriesData;
  loading: boolean;
  public users: Users[];
  public states: StateModel[];
  public regions: RegionModel[];
  loginName: BehaviorSubject<any> = new BehaviorSubject("");
  tseUsers: any[] = [];
  m2Users: any[] = [];
  m3Users: any[] = [];
  tmmUsers: any[] = [];

  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private router: Router
  ) { }
  userLogin(LoginForm: LoginForm): void {
    this.errorMessage = "";
    this.userService.userLogin(LoginForm).subscribe(
      (response) => {
        if (response.success) {
          localStorage.setItem("access-token", response.data.access_token);
          localStorage.setItem("userRole", response.data.user_role);
          localStorage.setItem("userId", response.data.id);
          localStorage.setItem("userName", response.data.user_name);
          this.loginName.next(localStorage.getItem("userName"));
          let user = response.data;
          this.loading = true;
          this.loggedInUser.Token = user.access_token;
          this.loggedInUser.isAuditor = false;
          this.loggedInUser.isModerator = true;
          if (response.data.user_role == 21) {
            this.router.navigate(['/tl-entries/tl-entries-data/']);
          } else {
            this.toastr.error(
              `Sorry, You don't have access to this module`,
              "Menu Programs",
              {
                timeOut: 10000,
                closeButton: true,
                positionClass: "toast-bottom-center",
              }
            );
            localStorage.clear();
            this.loading = false;
            return;
          }
          this.toastr.success("Logged in Successfully", "Success");
        } else {
          localStorage.removeItem("access-token");
          localStorage.removeItem("userRole");
          localStorage.removeItem("userId");
        }
      },
      (error) => {
        if (error.status == 422) {
          this.toastr.error(" Incorrect username or password ", "Error");
          this.errorMessage = " Incorrect username or password ";
          this.loading = false;
        }
      }
    );
  }

  updateNotificationsCount(id) {
    this.userService.getAllNotification(id).subscribe((data) => { });
  }


  getUserList(): void {
    this.userService.getAllUsers().subscribe((res: any) => {
      this.m2Users = res.m2users as any[];
      this.tseUsers = res.tseusers as any[];
      this.m3Users = res.m3users as any[];
      this.tmmUsers = res.tmmusers as any[];
      if (this.tseUsers.length > 0) {
        this.tseUsers.forEach(i => {
          i.name = i.user_detail_name + '-' + i.username;
          i.id = i.user_id;
        })
      }

      if (this.m2Users.length > 0) {
        this.m2Users.forEach(i => {
          i.name = i.user_detail_name + '-' + i.username;
          i.id = i.user_id;
        })
      }

      if (this.m3Users.length > 0) {
        this.m3Users.forEach(i => {
          i.name = i.user_detail_name + '-' + i.username;
          i.id = i.user_id;
        })
      }

      if (this.tmmUsers.length > 0) {
        this.tmmUsers.forEach(i => {
          i.name = i.user_detail_name + '-' + i.username;
          i.id = i.user_id;
        })
      }
    });
  }

  getStateList(): void {
    this.userService.getAllStates().subscribe((data) => {
      this.states = data;
      if (this.states.length > 0) {
        this.states.forEach(
          i => {
            i.id = i.state_code;
          }
        )
      }
    });
  }

  getRegionList(): void {
    this.userService.getAllRegions().subscribe((data) => {
      this.regions = data;
    });
  }
}
